export default function Ractive$findComponent ( selector ) {
	return this.fragment.findComponent( selector );
}
